<template>
  <div class="loading circle" :class="{position: applyPositionCSS, noDescText: !isShowDescText}">
    <div v-if="applyBackground" class="rectangle">
      <svg x="0px" y="0px" viewBox="0 0 150 150" :style="{ width: `${svgWidth}px`, marginTop: browser.isIE ? '-27px' : '0px' }">
        <circle class="loading-inner" cx="75" cy="75" r="60"/>
      </svg>
      <p v-if="isShowDescText" class="desc" :style="{ marginTop: browser.isIE ? '-15px': '12px' }"><slot>{{ $t('common.' + descText) }}</slot></p>
    </div>
    <div v-else>
      <svg x="0px" y="0px" viewBox="0 0 150 150" :style="`width:${svgWidth}px`">
        <circle class="loading-inner" cx="75" cy="75" r="60"/>
      </svg>
      <p v-if="isShowDescText" class="desc"><slot>{{ $t('common.' + descText) }}</slot></p>
    </div>
  </div>
</template>

<script>
import browser from '../../libs/browser'

export default {
  props: {
    svgWidth: {
      type: Number,
      default: 54,
      required: false
    },
    isShowDescText: {
      type: Boolean,
      default: true,
      required: false
    },
    descText: {
      type: String,
      default: 'loadingDot',
      required: false
    },
    applyPositionCSS: {
      type: Boolean,
      default: true,
      required: false
    },
    applyBackground: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      browser: browser
    }
  }
}
</script>

<style lang="scss" scoped>
  .loading {
    display: inline-block;
    z-index: 11;
    &.noDescText:not(.position) svg {
      vertical-align: text-bottom;
      margin-right: 9px;
    }
    &.position {
      text-align: center;
      position: absolute;
      top: calc(50% - 5%);
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .rectangle {
      padding-top: 30px;
      margin: auto;
      width: 140px;
      height: 110px;
      top: 50%;
      border-radius: 14px;
      box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
      background-color: rgba(255, 255, 255, 0.8);
    }
    svg {
      animation: loading 3s linear infinite;

      .loading-inner {
        stroke: {
          dashoffset: 0;
          dasharray: 300;
          width: 20;
          miterlimit: 10;
          linecap: round;
        }

        animation: loading-circle 2s linear infinite;
        stroke: $brandColor;
        fill: transparent;
      }
    }
    p {
      margin-top: 12px;
      font-size: 13px;
      font-weight: 500;
      line-height: 1;
      text-align: center;
      color: #444444;
    }
    &.ie p {
      margin-top: -30px;
    }
    @keyframes loading {
      0% {
        transform: rotate(0);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    @keyframes loading-circle {
      0% {
        stroke-dashoffset: 0
      }
      100% {
        stroke-dashoffset: -600;
      }
    }
  }
</style>
